import { cn } from "~/lib/render-utils";
import { Header } from "./header";
import { Footer } from "./footer";

interface LayoutProps {
  children: React.ReactNode;
  className?: string;
}

export function Layout({ children, className }: LayoutProps) {
  return (
    <>
      <Header />
      
      <main className={cn("flex-1", className)}>
        {children}
      </main>
      
      <Footer />
    </>
  );
} 